import React from 'react';
import Loadable from 'react-loadable';

const ReactPlayer = Loadable({
  loader: () => import('./index.lazy'),
  loading: () => (<div />),
});

export default ReactPlayer;
